// extracted by mini-css-extract-plugin
export default {"modal":"AlertModal_modal__NfWE6","header":"AlertModal_header__MIHOc","body":"AlertModal_body__Z9z4C","footer":"AlertModal_footer__H91CL","button":"AlertModal_button__xaiti"};